import { StylovyzeIconProps } from '@innovyze/stylovyze';
import React from 'react';

const BernoulliIcon: React.FC<StylovyzeIconProps> = ({ color }) => {
  const stroke = color || 'currentColor';

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="4"
        y="6"
        width="14"
        height="9"
        rx="2"
        ry="2"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path
        d="M11 15L10 18L13 15"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="none"
      />

      <line
        x1="7"
        y1="9"
        x2="15"
        y2="9"
        stroke={stroke}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <line
        x1="7"
        y1="12"
        x2="13"
        y2="12"
        stroke={stroke}
        strokeWidth="1.4"
        strokeLinecap="round"
      />

      <path
        d="M19.5 4L21 5.5L19.5 7L18 5.5L19.5 4Z"
        stroke={stroke}
        strokeWidth="1.4"
        fill="none"
      />
    </svg>
  );
};

export default BernoulliIcon;
